"use strict";
/**
 * Orders Module – Central Export Hub
 *
 * All order-related logic is split into focused submodules under `./orders/`.
 * This barrel re-exports every public symbol so that the rest of the app
 * can import from `"../orders"` with a single path.
 *
 * Submodules:
 * - `validation`   – Pre-flight validation for order requests
 * - `creation`     – Build Kalshi order requests from state
 * - `execution`    – Place orders via the correct provider
 * - `status`       – Fetch order status / cancel
 * - `formatting`   – Status badge rendering
 * - `calculations` – Cost estimation and PnL helpers
 * - `positions`    – Position fetching
 * - `types`        – Shared type definitions
 *
 * @module orders
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePnL = exports.estimateOrderCost = exports.getOrderStatusBadge = exports.cancelExistingOrder = exports.getOrderStatus = exports.placeNewOrder = exports.createOrderRequest = exports.validateOrderRequest = void 0;
// Validation
var validation_1 = require("./orders/validation");
Object.defineProperty(exports, "validateOrderRequest", { enumerable: true, get: function () { return validation_1.validateOrderRequest; } });
// Order Creation
var creation_1 = require("./orders/creation");
Object.defineProperty(exports, "createOrderRequest", { enumerable: true, get: function () { return creation_1.createOrderRequest; } });
// Order Execution
var execution_1 = require("./orders/execution");
Object.defineProperty(exports, "placeNewOrder", { enumerable: true, get: function () { return execution_1.placeNewOrder; } });
// Order Status
var status_1 = require("./orders/status");
Object.defineProperty(exports, "getOrderStatus", { enumerable: true, get: function () { return status_1.getOrderStatus; } });
Object.defineProperty(exports, "cancelExistingOrder", { enumerable: true, get: function () { return status_1.cancelExistingOrder; } });
// Formatting
var formatting_1 = require("./orders/formatting");
Object.defineProperty(exports, "getOrderStatusBadge", { enumerable: true, get: function () { return formatting_1.getOrderStatusBadge; } });
// Calculations
var calculations_1 = require("./orders/calculations");
Object.defineProperty(exports, "estimateOrderCost", { enumerable: true, get: function () { return calculations_1.estimateOrderCost; } });
Object.defineProperty(exports, "calculatePnL", { enumerable: true, get: function () { return calculations_1.calculatePnL; } });
